// SignIn.js
import React, { useState } from "react";
import useForm from "../../utils/useForm";
import validate from "../../utils/validateLoginForm";
import bvaLogo from "../../assets/bva-logo.png";
import BVAButton from "../BVAButton/BVAButton";
import axios from "axios";
import SubscriptionModal from "./SubscriptionModal";
import ServerCall from "../../serverCall";
import toast from "react-hot-toast";

const SignIn = ({ email, password, handleChange, onSignIn = () => ({}),setLoading,loading,isModalVisible, setIsModalVisible, userId, setUserId }) => {
  const [newUser, setNewUser] = useState(false);
  const [reset, setReset] = useState(false);
  const [errors] = useForm(validate, reset);
  const serverCall = ServerCall();

  const handleSignUp = async () => {
    const raw = JSON.stringify({ email, password });
    
    try {
      const response = await serverCall.customAxios.post("/signup", raw, {
        headers: { "Content-Type": "application/json" }
      });
      setNewUser(false);
      setUserId(response?.data?.uid);
      //// temporarily disabled first payment for signup
      //// setIsModalVisible(true); // Open the subscription modal upon successful signup
      toast.success("You have successfully signed up. Please sign in with your credential.");
      //// temporarily disabled first payment for signup
    } catch (error) {
      alert(error.response.data.error)
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (errors.email) {
      setReset(true);
    }
    if (email) {
      const myHeaders = {
        "Content-Type": "application/json",
      };

      const raw = JSON.stringify({
        email,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        data: raw,
        url: "https://us-central1-loyal-framework-352018.cloudfunctions.net/api/api/resetPassword",
      };

      try {
        await axios(requestOptions);
        window.alert("Password reset email sent");
      } catch (error) {
        window.alert(error.message);
        setReset(false);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (newUser) {
      await handleSignUp();
    } else {
      if (reset) {
        await handleResetPassword();
      } else {
         onSignIn();
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login">
        <div className="flex items-center flex-col">
          <img src={bvaLogo} className="w-60" alt="BVA Logo" />
          <h2 className="mt-4">
            {reset ? "Reset password" : newUser ? "Create an account" : "Sign in"}
          </h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              placeholder="Your e-mail"
              onChange={handleChange}
              className={
                (errors.emailIsEmpty || errors.emailFormatInvalid) && "input-error"
              }
            />
            {errors.emailIsEmpty && <small>{errors.emailIsEmpty}</small>}
            {errors.emailFormatInvalid && (
              <small>{errors.emailFormatInvalid}</small>
            )}
          </div>
          {!reset && (
            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                placeholder="Your password"
                onChange={handleChange}
                className={
                  (errors.passIsStrong || errors.passIsEmpty) && "input-error"
                }
              />
              {errors.passIsStrong && <small>{errors.passIsStrong}</small>}
              {errors.passIsEmpty && <small>{errors.passIsEmpty}</small>}
            </div>
          )}
          <div className="flex items-center">
            <BVAButton loading={loading} type="submit" kind="primary">
              {reset
                ? "Reset password"
                : newUser
                ? "Create account"
                : "Sign in"}
            </BVAButton>
            {!newUser && !reset && (
              <div className="ml-2">
                <BVAButton kind="primary-transparent" onClick={() => setReset(true)}>
                  Forgot password?
                </BVAButton>
              </div>
            )}
            {reset && (
              <div className="ml-2">
                <BVAButton kind="primary-transparent" onClick={() => setReset(false)} className="btn-link">
                  Back to sign in
                </BVAButton>
              </div>
            )}
          </div>
        </form>
        <div className="mt-10 flex items-center flex-col">
          <p>
            {newUser
              ? "Already have an account?"
              : "Don't have an account yet?"}
          </p>
          <div className="mt-4">
            <BVAButton
              onClick={() => {
                setNewUser(!newUser);
                if (reset) setReset(false);
              }}
              kind="primary-outlined"
            >
              {newUser ? "Sign in" : "Create an account"}
            </BVAButton>
          </div>
        </div>
      </div>
      <SubscriptionModal open={isModalVisible} onClose={() => setIsModalVisible(false)} userId={userId} />
    </div>
  );
};

export default SignIn;
